



// import React, {
//   useState,
//   useEffect,
//   useRef,
// } from 'react';

// import {
//   ResponsiveContainer,
//   // LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   AreaChart,
//   Area,
// } from 'recharts';

// import html2pdf from 'html2pdf.js';
// import CalculatorForm from './CalculatorForm';
// import { motion } from 'framer-motion';

// import {
//   FaChartLine,
//   FaFilePdf,
//   FaArrowTrendUp,
//   FaMoneyBillTrendUp,
// } from 'react-icons/fa6';

// const StepUpSIPCalculator = () => {
//   const [monthlyInvestment, setMonthlyInvestment] =
//     useState(5000);

//   const [stepUpRate, setStepUpRate] =
//     useState(10);

//   const [expectedReturn, setExpectedReturn] =
//     useState(12);

//   const [inflationRate, setInflationRate] =
//     useState(6);

//   const [timePeriod, setTimePeriod] =
//     useState(10);

//   const [showForm, setShowForm] =
//     useState(false);

//   const [result, setResult] =
//     useState(null);

//   const [chartData, setChartData] =
//     useState([]);

//   // NEW
//   const resultRef = useRef(null);

//   const formatCurrency = (value) => {
//     return Number(value).toLocaleString(
//       'en-IN'
//     );
//   };

//   const calculate = () => {
//     let totalInvestment = 0;

//     let futureValue = 0;

//     let inflationAdjustedValue = 0;

//     let currentMonthly =
//       monthlyInvestment;

//     const monthlyRate =
//       expectedReturn / 12 / 100;

//     const inflationAdjustedReturn =
//       ((1 + expectedReturn / 100) /
//         (1 + inflationRate / 100) -
//         1) *
//       100;

//     const realMonthlyRate =
//       inflationAdjustedReturn /
//       12 /
//       100;

//     const data = [];

//     for (
//       let year = 1;
//       year <= timePeriod;
//       year++
//     ) {
//       let yearInvestment = 0;

//       for (
//         let month = 1;
//         month <= 12;
//         month++
//       ) {
//         yearInvestment += currentMonthly;

//         futureValue =
//           (futureValue +
//             currentMonthly) *
//           (1 + monthlyRate);

//         inflationAdjustedValue =
//           (inflationAdjustedValue +
//             currentMonthly) *
//           (1 + realMonthlyRate);
//       }

//       totalInvestment += yearInvestment;

//       data.push({
//         year: `${year}Y`,

//         investment:
//           Math.round(totalInvestment),

//         value:
//           Math.round(futureValue),

//         inflationAdjusted:
//           Math.round(
//             inflationAdjustedValue
//           ),

//         monthlySIP:
//           Math.round(currentMonthly),
//       });

//       currentMonthly =
//         currentMonthly *
//         (1 + stepUpRate / 100);
//     }

//     const estimatedReturns =
//       futureValue - totalInvestment;

//     const regularSIPFutureValue =
//       monthlyInvestment *
//       ((Math.pow(
//         1 + monthlyRate,
//         timePeriod * 12
//       ) -
//         1) /
//         monthlyRate) *
//       (1 + monthlyRate);

//     const extraGain =
//       futureValue -
//       regularSIPFutureValue;

//     const gainPercentage =
//       ((futureValue /
//         regularSIPFutureValue -
//         1) *
//         100).toFixed(1);

//     // NEW
//     // const inflationLoss =
//     //   futureValue -
//     //   inflationAdjustedValue;

//     const inflationLoss = Math.max(
//   0,
//   futureValue -
//     inflationAdjustedValue
// );

//     setResult({
//       futureValue,
//       totalInvestment,
//       estimatedReturns,
//       inflationAdjustedValue,
//       inflationLoss,
//       finalMonthlySIP:
//         currentMonthly,
//       regularSIPFutureValue,
//       extraGain,
//       gainPercentage,
//     });

//     setChartData(data);
//   };

//   // AUTO SCROLL MOBILE
//   useEffect(() => {
//     if (
//       result &&
//       window.innerWidth < 1024
//     ) {
//       setTimeout(() => {
//         resultRef.current?.scrollIntoView({
//           behavior: 'smooth',
//           block: 'start',
//         });
//       }, 200);
//     }
//   }, [result]);

//   const handleFormSubmit = (
//     userData
//   ) => {
//     const element =
//       document.getElementById(
//         'stepup-result-content'
//       );

//     const opt = {
//       margin: [0.4, 0.4, 0.4, 0.4],

//       filename: `Wisdom_StepUp_SIP_Report_${userData.name}.pdf`,

//       image: {
//         type: 'jpeg',
//         quality: 1,
//       },

//       html2canvas: {
//         scale: 2,
//       },

//       jsPDF: {
//         unit: 'in',
//         format: 'a4',
//         orientation: 'portrait',
//       },
//     };

//     html2pdf()
//       .set(opt)
//       .from(element)
//       .save();

//     setShowForm(false);

//     const whatsappMessage = 
//     `Hello ${userData.name},

// 📈 Step-Up SIP Investment Summary

// ━━━━━━━━━━━━━━━

// 💰 Initial Monthly SIP:
// ₹${formatCurrency(
//       monthlyInvestment
//     )}

// 📊 Annual Step-Up:
// ${stepUpRate}%

// 📈 Expected Return:
// ${expectedReturn}% p.a.

// 📉 Inflation Rate:
// ${inflationRate}% p.a.

// ⏳ Investment Duration:
// ${timePeriod} Years

// ━━━━━━━━━━━━━━━

// 💼 Total Investment:
// ₹${formatCurrency(
//       result.totalInvestment
//     )}

// 📈 Estimated Returns:
// ₹${formatCurrency(
//       result.estimatedReturns
//     )}

// 🏆 Future Value:
// ₹${formatCurrency(
//       result.futureValue
//     )}

// 📉 Inflation Adjusted Value:
// ₹${formatCurrency(
//       result.inflationAdjustedValue
//     )}

// ━━━━━━━━━━━━━━━

// Wisdom Consultancy
// `;

//     window.open(
//       `https://wa.me/91${userData.phone}?text=${encodeURIComponent(
//         whatsappMessage
//       )}`,
//       '_blank'
//     );
//   };

//   return (
//     <motion.div
//       initial={{
//         opacity: 0,
//         y: 20,
//       }}
//       animate={{
//         opacity: 1,
//         y: 0,
//       }}
//       className="w-full"
//     >
//       {/* HEADER */}
//       <div className="mb-10">
//         <div className="inline-flex items-center gap-3 bg-[#edf3ff] px-5 py-3 rounded-full mb-5">
//           <div className="w-11 h-11 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
//             <FaMoneyBillTrendUp />
//           </div>

//           <span className="font-semibold text-[#0b1c39]">
//             Advanced Wealth Planning
//           </span>
//         </div>

//         <h2 className="text-4xl md:text-5xl font-bold text-[#0b1c39] mb-4">
//           Step-Up SIP Calculator
//         </h2>

//         <p className="text-gray-600 text-lg leading-8 max-w-3xl">
//           Increase your SIP annually and
//           maximize long-term wealth
//           creation with inflation-adjusted
//           investment projections.
//         </p>
//       </div>

//       <div className="grid lg:grid-cols-2 gap-10">
//         {/* LEFT SECTION */}
//         <div className="space-y-6">
//           {/* INITIAL SIP */}
//           <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
//             <div className="flex items-center justify-between mb-5">
//               <label className="font-bold text-[#0b1c39] text-lg">
//                 Initial Monthly SIP
//               </label>

//               <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-[#2e56b8]">
//                 ₹
//                 {formatCurrency(
//                   monthlyInvestment
//                 )}
//               </div>
//             </div>

//             <input
//               type="range"
//               min="500"
//               max="100000"
//               step="500"
//               value={monthlyInvestment}
//               onChange={(e) =>
//                 setMonthlyInvestment(
//                   Number(
//                     e.target.value
//                   )
//                 )
//               }
//               className="w-full accent-[#2e56b8]"
//             />

//             <div className="flex justify-between text-sm text-gray-500 mt-3">
//               <span>₹500</span>

//               <span>₹1,00,000</span>
//             </div>
//           </div>

//           {/* STEP UP */}
//           <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
//             <div className="flex items-center justify-between mb-5">
//               <label className="font-bold text-[#0b1c39] text-lg">
//                 Annual Step-Up Rate
//               </label>

//               <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-[#69bf74]">
//                 {stepUpRate}%
//               </div>
//             </div>

//             <input
//               type="range"
//               min="0"
//               max="25"
//               step="1"
//               value={stepUpRate}
//               onChange={(e) =>
//                 setStepUpRate(
//                   Number(
//                     e.target.value
//                   )
//                 )
//               }
//               className="w-full accent-[#69bf74]"
//             />

//             <div className="flex justify-between text-sm text-gray-500 mt-3">
//               <span>0%</span>

//               <span>25%</span>
//             </div>
//           </div>

//           {/* RETURN */}
//           <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
//             <div className="flex items-center justify-between mb-5">
//               <label className="font-bold text-[#0b1c39] text-lg">
//                 Expected Return
//               </label>

//               <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-orange-500">
//                 {expectedReturn}%
//               </div>
//             </div>

//             <input
//               type="range"
//               min="1"
//               max="30"
//               step="0.5"
//               value={expectedReturn}
//               onChange={(e) =>
//                 setExpectedReturn(
//                   Number(
//                     e.target.value
//                   )
//                 )
//               }
//               className="w-full accent-orange-500"
//             />

//             <div className="flex justify-between text-sm text-gray-500 mt-3">
//               <span>1%</span>

//               <span>30%</span>
//             </div>
//           </div>

//           {/* INFLATION */}
//           <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
//             <div className="flex items-center justify-between mb-5">
//               <label className="font-bold text-[#0b1c39] text-lg">
//                 Inflation Rate
//               </label>

//               <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-pink-500">
//                 {inflationRate}%
//               </div>
//             </div>

//             <input
//               type="range"
//               min="0"
//               max="15"
//               step="0.5"
//               value={inflationRate}
//               onChange={(e) =>
//                 setInflationRate(
//                   Number(
//                     e.target.value
//                   )
//                 )
//               }
//               className="w-full accent-pink-500"
//             />

//             <div className="flex justify-between text-sm text-gray-500 mt-3">
//               <span>0%</span>

//               <span>15%</span>
//             </div>


//            {/* INFLATION IMPACT */}
// {result?.inflationLoss > 0 && (
//   <motion.div
//     initial={{
//       opacity: 0,
//       y: 10,
//     }}
//     animate={{
//       opacity: 1,
//       y: 0,
//     }}
//     className="mt-5 bg-gradient-to-r from-pink-50 to-orange-50 border border-pink-200 rounded-2xl p-5 shadow-sm"
//   >
//     <div className="flex items-center justify-between">
//       <div>
//         <p className="text-sm text-gray-500 mb-1">
//           Inflation Impact
//         </p>

//         <h3 className="text-2xl font-bold text-pink-500">
//           ₹
//           {formatCurrency(
//             result.inflationLoss
//           )}
//         </h3>
//       </div>

//       <div className="w-12 h-12 rounded-full bg-pink-100 flex items-center justify-center text-pink-500 text-xl">
//         📉
//       </div>
//     </div>

//     <p className="text-xs text-gray-500 mt-3 leading-5">
//       This shows how inflation reduces
//       your actual purchasing power over
//       time.
//     </p>
//   </motion.div>
// )}

//           </div>

//           {/* TIME PERIOD */}
//           <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
//             <div className="flex items-center justify-between mb-5">
//               <label className="font-bold text-[#0b1c39] text-lg">
//                 Investment Duration
//               </label>

//               <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-[#2e56b8]">
//                 {timePeriod} Years
//               </div>
//             </div>

//             <input
//               type="range"
//               min="1"
//               max="40"
//               value={timePeriod}
//               onChange={(e) =>
//                 setTimePeriod(
//                   Number(
//                     e.target.value
//                   )
//                 )
//               }
//               className="w-full accent-[#2e56b8]"
//             />

//             <div className="flex justify-between text-sm text-gray-500 mt-3">
//               <span>1 Year</span>

//               <span>40 Years</span>
//             </div>
//           </div>

//           {/* BUTTON */}
//           <button
//             onClick={calculate}
//             className="w-full bg-[#2e56b8] hover:bg-[#24479b] text-white py-5 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-xl"
//           >
//             Calculate Step-Up SIP
//           </button>
//         </div>

//         {/* RIGHT RESULT */}
//         {result && (
//           <motion.div
//             ref={resultRef}
//             initial={{
//               opacity: 0,
//             }}
//             animate={{
//               opacity: 1,
//             }}
//             className="bg-gradient-to-br from-[#edf3ff] to-[#eef8f1] border border-[#dce7ff] rounded-[35px] p-7"
//           >
//             <div className="flex items-center gap-3 mb-8">
//               <div className="w-14 h-14 rounded-2xl bg-[#2e56b8] text-white flex items-center justify-center">
//                 <FaChartLine size={24} />
//               </div>

//               <div>
//                 <h3 className="text-3xl font-bold text-[#0b1c39]">
//                   Investment Summary
//                 </h3>

//                 <p className="text-gray-500">
//                   Step-Up SIP Growth
//                 </p>
//               </div>
//             </div>

//             <div className="space-y-5">
//               <div className="bg-white rounded-2xl p-5 flex justify-between">
//                 <span>
//                   Total Investment
//                 </span>

//                 <span className="font-bold">
//                   ₹
//                   {formatCurrency(
//                     result.totalInvestment
//                   )}
//                 </span>
//               </div>

//               <div className="bg-white rounded-2xl p-5 flex justify-between">
//                 <span>
//                   Estimated Returns
//                 </span>

//                 <span className="font-bold text-[#69bf74]">
//                   ₹
//                   {formatCurrency(
//                     result.estimatedReturns
//                   )}
//                 </span>
//               </div>

//               <div className="bg-white rounded-2xl p-5 flex justify-between">
//                 <span>
//                   Inflation Adjusted
//                   Value
//                 </span>

//                 <span className="font-bold text-orange-500">
//                   ₹
//                   {formatCurrency(
//                     result.inflationAdjustedValue
//                   )}
//                 </span>
//               </div>

//               <div className="bg-[#2e56b8] rounded-[30px] p-7 text-white shadow-xl">
//                 <p className="text-white/80 mb-3 text-lg">
//                   Final Future Value
//                 </p>

//                 <h2 className="text-4xl md:text-5xl font-extrabold mb-4">
//                   ₹
//                   {formatCurrency(
//                     result.futureValue
//                   )}
//                 </h2>

//                 <div className="flex items-center gap-2 text-white/90">
//                   <FaArrowTrendUp />

//                   <span>
//                     Additional Gain:{' '}
//                     {
//                       result.gainPercentage
//                     }
//                     %
//                   </span>
//                 </div>
//               </div>

//               {/* COMPARISON */}
//               <div className="bg-white rounded-3xl p-6 border border-[#e8efff]">
//                 <h4 className="font-bold text-[#0b1c39] mb-4">
//                   Regular SIP vs
//                   Step-Up SIP
//                 </h4>

//                 <div className="space-y-3 text-sm">
//                   <div className="flex justify-between">
//                     <span>
//                       Regular SIP Value
//                     </span>

//                     <span className="font-semibold">
//                       ₹
//                       {formatCurrency(
//                         result.regularSIPFutureValue
//                       )}
//                     </span>
//                   </div>

//                   <div className="flex justify-between">
//                     <span>
//                       Extra Gain
//                     </span>

//                     <span className="font-semibold text-[#69bf74]">
//                       ₹
//                       {formatCurrency(
//                         result.extraGain
//                       )}
//                     </span>
//                   </div>

//                   <div className="flex justify-between">
//                     <span>
//                       Additional Return
//                     </span>

//                     <span className="font-semibold text-[#69bf74]">
//                       +
//                       {
//                         result.gainPercentage
//                       }
//                       %
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* DOWNLOAD */}
//             <button
//               onClick={() =>
//                 setShowForm(true)
//               }
//               className="w-full mt-8 bg-[#69bf74] hover:bg-[#58ab63] text-white py-4 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-lg flex items-center justify-center gap-3"
//             >
//               <FaFilePdf />
//               Download Professional PDF
//               Report
//             </button>
//           </motion.div>
//         )}
//       </div>

//       {/* CHART */}
//       {chartData.length > 0 && (
//         <motion.div
//           initial={{
//             opacity: 0,
//           }}
//           animate={{
//             opacity: 1,
//           }}
//           className="mt-16"
//         >
//           <h3 className="text-3xl font-bold text-[#0b1c39] mb-8">
//             Investment Growth
//             Projection
//           </h3>

//           <div className="bg-[#f8fbff] rounded-[35px] border border-[#edf3ff] p-6">
//             <div className="h-[450px]">
//               <ResponsiveContainer
//                 width="100%"
//                 height="100%"
//               >
//                 <AreaChart
//                   data={chartData}
//                 >
//                   <defs>
//                     <linearGradient
//                       id="colorStep"
//                       x1="0"
//                       y1="0"
//                       x2="0"
//                       y2="1"
//                     >
//                       <stop
//                         offset="5%"
//                         stopColor="#69bf74"
//                         stopOpacity={0.4}
//                       />

//                       <stop
//                         offset="95%"
//                         stopColor="#69bf74"
//                         stopOpacity={0}
//                       />
//                     </linearGradient>
//                   </defs>

//                   <CartesianGrid strokeDasharray="3 3" />

//                   <XAxis dataKey="year" />

//                   <YAxis />

//                   <Tooltip
//                     formatter={(
//                       value
//                     ) =>
//                       `₹${formatCurrency(
//                         value
//                       )}`
//                     }
//                   />

//                   <Legend />

//                   <Area
//                     type="monotone"
//                     dataKey="value"
//                     stroke="#69bf74"
//                     fillOpacity={1}
//                     fill="url(#colorStep)"
//                     strokeWidth={3}
//                     name="Portfolio Value"
//                   />

//                   <Line
//                     type="monotone"
//                     dataKey="investment"
//                     stroke="#2e56b8"
//                     strokeWidth={3}
//                     name="Total Investment"
//                   />

//                   <Line
//                     type="monotone"
//                     dataKey="inflationAdjusted"
//                     stroke="#ff9800"
//                     strokeWidth={3}
//                     name="Inflation Adjusted"
//                   />
//                 </AreaChart>
//               </ResponsiveContainer>
//             </div>
//           </div>
//         </motion.div>
//       )}

//       {/* PDF CONTENT */}
//       {result && (
//         <div
//           id="stepup-result-content"
//           style={{
//             display: 'none',
//           }}
//         >
//           {/* SAME PDF CONTENT */}
//         </div>
//       )}

//       {/* FORM */}
//       {showForm && (
//         <CalculatorForm
//           onSubmit={
//             handleFormSubmit
//           }
//           onClose={() =>
//             setShowForm(false)
//           }
//           calculatorType="Step-Up SIP"
//         />
//       )}
//     </motion.div>
//   );
// };

// export default StepUpSIPCalculator;

import React, {
  useState,
  useEffect,
  useRef,
} from 'react';

import {
  ResponsiveContainer,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  AreaChart,
  Area,
} from 'recharts';

import html2pdf from 'html2pdf.js';
import CalculatorForm from './CalculatorForm';
import { motion } from 'framer-motion';

import {
  FaChartLine,
  FaFilePdf,
  FaArrowTrendUp,
  FaMoneyBillTrendUp,
} from 'react-icons/fa6';

const StepUpSIPCalculator = () => {
  const [monthlyInvestment, setMonthlyInvestment] =
    useState(5000);

  const [stepUpRate, setStepUpRate] =
    useState(10);

  const [expectedReturn, setExpectedReturn] =
    useState(12);

  const [inflationRate, setInflationRate] =
    useState(6);

  const [timePeriod, setTimePeriod] =
    useState(10);

  const [showForm, setShowForm] =
    useState(false);

  const [result, setResult] =
    useState(null);

  const [chartData, setChartData] =
    useState([]);

  const resultRef = useRef(null);

  const formatCurrency = (value) => {
    return Number(value).toLocaleString(
      'en-IN'
    );
  };

  const calculate = () => {
    let totalInvestment = 0;
    let futureValue = 0;
    let inflationAdjustedValue = 0;
    let currentMonthly = monthlyInvestment;

    const monthlyRate = expectedReturn / 12 / 100;

    const inflationAdjustedReturn = ((1 + expectedReturn / 100) / (1 + inflationRate / 100) - 1) * 100;
    const realMonthlyRate = inflationAdjustedReturn / 12 / 100;

    const data = [];

    for (let year = 1; year <= timePeriod; year++) {
      let yearInvestment = 0;

      for (let month = 1; month <= 12; month++) {
        yearInvestment += currentMonthly;
        futureValue = (futureValue + currentMonthly) * (1 + monthlyRate);
        inflationAdjustedValue = (inflationAdjustedValue + currentMonthly) * (1 + realMonthlyRate);
      }

      totalInvestment += yearInvestment;

      data.push({
        year: `${year}Y`,
        investment: Math.round(totalInvestment),
        value: Math.round(futureValue),
        inflationAdjusted: Math.round(inflationAdjustedValue),
        monthlySIP: Math.round(currentMonthly),
      });

      currentMonthly = currentMonthly * (1 + stepUpRate / 100);
    }

    const estimatedReturns = futureValue - totalInvestment;
    const inflationLossValue = futureValue - inflationAdjustedValue;
    const purchasingPowerLoss = totalInvestment - inflationAdjustedValue;

    const regularSIPFutureValue = monthlyInvestment *
      ((Math.pow(1 + monthlyRate, timePeriod * 12) - 1) / monthlyRate) * (1 + monthlyRate);

    const extraGain = futureValue - regularSIPFutureValue;
    const gainPercentage = ((futureValue / regularSIPFutureValue - 1) * 100).toFixed(1);
    const inflationLoss = Math.max(0, futureValue - inflationAdjustedValue);

    setResult({
      futureValue,
      totalInvestment,
      estimatedReturns,
      inflationAdjustedValue,
      inflationLoss,
      inflationLossValue,
      purchasingPowerLoss,
      finalMonthlySIP: currentMonthly,
      regularSIPFutureValue,
      extraGain,
      gainPercentage,
    });

    setChartData(data);
  };

  useEffect(() => {
    calculate();
  }, [monthlyInvestment, stepUpRate, expectedReturn, inflationRate, timePeriod]);

  useEffect(() => {
    if (result && window.innerWidth < 1024) {
      setTimeout(() => {
        resultRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 200);
    }
  }, [result]);

  const handleFormSubmit = (userData) => {
    const element = document.getElementById('stepup-result-content');

    const opt = {
      margin: [0.4, 0.4, 0.4, 0.4],
      filename: `Wisdom_StepUp_SIP_Report_${userData.name}.pdf`,
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
    };

    html2pdf().set(opt).from(element).save();
    setShowForm(false);

    const whatsappMessage = `Hello ${userData.name},

📈 Step-Up SIP Investment Summary

━━━━━━━━━━━━━━━

💰 Initial Monthly SIP: ₹${formatCurrency(monthlyInvestment)}
📊 Annual Step-Up: ${stepUpRate}%
📈 Expected Return: ${expectedReturn}% p.a.
📉 Inflation Rate: ${inflationRate}% p.a.
⏳ Investment Duration: ${timePeriod} Years

━━━━━━━━━━━━━━━

💼 Total Investment: ₹${formatCurrency(result.totalInvestment)}
📈 Estimated Returns: ₹${formatCurrency(result.estimatedReturns)}
🏆 Future Value: ₹${formatCurrency(result.futureValue)}

━━━━━━━━━━━━━━━

📉 *Inflation Impact Details*

💰 Today's Value of Investment: ₹${formatCurrency(result.totalInvestment)}
📉 Purchasing Power Loss: ₹${formatCurrency(result.purchasingPowerLoss)}
🏦 Inflation Adjusted Value: ₹${formatCurrency(result.inflationAdjustedValue)}
💸 Total Value Lost to Inflation: ₹${formatCurrency(result.inflationLossValue)}

━━━━━━━━━━━━━━━

Wisdom Consultancy
📞 9726344477
📧 wisdom2secure@gmail.com`;

    window.open(`https://wa.me/91${userData.phone}?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="w-full"
    >
      {/* HEADER */}
      <div className="mb-10">
        <div className="inline-flex items-center gap-3 bg-[#edf3ff] px-5 py-3 rounded-full mb-5">
          <div className="w-11 h-11 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
            <FaMoneyBillTrendUp />
          </div>
          <span className="font-semibold text-[#0b1c39]">
            Advanced Wealth Planning
          </span>
        </div>

        <h2 className="text-4xl md:text-5xl font-bold text-[#0b1c39] mb-4">
          Step-Up SIP Calculator
        </h2>

        <p className="text-gray-600 text-lg leading-8 max-w-3xl">
          Increase your SIP annually and maximize long-term wealth
          creation with inflation-adjusted investment projections.
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-10">
        {/* LEFT SECTION */}
        <div className="space-y-6">
          {/* INITIAL SIP */}
          <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
            <div className="flex items-center justify-between mb-5">
              <label className="font-bold text-[#0b1c39] text-lg">
                Initial Monthly SIP
              </label>
              <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-[#2e56b8]">
                ₹{formatCurrency(monthlyInvestment)}
              </div>
            </div>
            <input
              type="range"
              min="500"
              max="100000"
              step="500"
              value={monthlyInvestment}
              onChange={(e) => setMonthlyInvestment(Number(e.target.value))}
              className="w-full accent-[#2e56b8]"
            />
            <div className="flex justify-between text-sm text-gray-500 mt-3">
              <span>₹500</span>
              <span>₹1,00,000</span>
            </div>
          </div>

          {/* STEP UP */}
          <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
            <div className="flex items-center justify-between mb-5">
              <label className="font-bold text-[#0b1c39] text-lg">
                Annual Step-Up Rate
              </label>
              <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-[#69bf74]">
                {stepUpRate}%
              </div>
            </div>
            <input
              type="range"
              min="0"
              max="25"
              step="1"
              value={stepUpRate}
              onChange={(e) => setStepUpRate(Number(e.target.value))}
              className="w-full accent-[#69bf74]"
            />
            <div className="flex justify-between text-sm text-gray-500 mt-3">
              <span>0%</span>
              <span>25%</span>
            </div>
          </div>

          {/* RETURN */}
          <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
            <div className="flex items-center justify-between mb-5">
              <label className="font-bold text-[#0b1c39] text-lg">
                Expected Return
              </label>
              <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-orange-500">
                {expectedReturn}%
              </div>
            </div>
            <input
              type="range"
              min="1"
              max="30"
              step="0.5"
              value={expectedReturn}
              onChange={(e) => setExpectedReturn(Number(e.target.value))}
              className="w-full accent-orange-500"
            />
            <div className="flex justify-between text-sm text-gray-500 mt-3">
              <span>1%</span>
              <span>30%</span>
            </div>
          </div>

          {/* INFLATION */}
          <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
            <div className="flex items-center justify-between mb-5">
              <label className="font-bold text-[#0b1c39] text-lg">
                Inflation Rate
              </label>
              <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-pink-500">
                {inflationRate}%
              </div>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.5"
              value={inflationRate}
              onChange={(e) => setInflationRate(Number(e.target.value))}
              className="w-full accent-pink-500"
            />
            <div className="flex justify-between text-sm text-gray-500 mt-3">
              <span>0%</span>
              <span>15%</span>
            </div>

            {/* INFLATION IMPACT CARDS - TWO OPTIONS DISPLAY */}
            {result?.inflationLoss > 0 && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className="mt-5 space-y-3"
              >
                {/* Option 1: Purchasing Power Loss */}
                <div className="bg-gradient-to-r from-pink-50 to-rose-50 border border-pink-200 rounded-2xl p-4 shadow-sm">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-gray-500 mb-1 flex items-center gap-1">
                        <span className="text-pink-400 text-xs">ℹ️</span>
                        Today's Value of Investment
                      </p>
                      <h3 className="text-xl font-bold text-gray-800">
                        ₹{formatCurrency(result.totalInvestment)}
                      </h3>
                    </div>
                    <div className="w-10 h-10 rounded-full bg-pink-100 flex items-center justify-center text-pink-500 text-lg">
                      📉
                    </div>
                  </div>
                  <div className="mt-3 pt-3 border-t border-pink-100">
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-500">Purchasing Power Loss:</span>
                      <span className="font-bold text-pink-600">-₹{formatCurrency(result.purchasingPowerLoss)}</span>
                    </div>
                  </div>
                </div>

                {/* Option 2: Inflation Adjusted Value */}
                <div className="bg-gradient-to-r from-orange-50 to-amber-50 border border-orange-200 rounded-2xl p-4 shadow-sm">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-gray-500 mb-1 flex items-center gap-1">
                        <span className="text-orange-400 text-xs">ℹ️</span>
                        Inflation Adjusted Future Value
                      </p>
                      <h3 className="text-xl font-bold text-orange-600">
                        ₹{formatCurrency(result.inflationAdjustedValue)}
                      </h3>
                    </div>
                    <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-500 text-lg">
                      💰
                    </div>
                  </div>
                  <div className="mt-3 pt-3 border-t border-orange-100">
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-500">Total Value Lost to Inflation:</span>
                      <span className="font-bold text-orange-600">-₹{formatCurrency(result.inflationLossValue)}</span>
                    </div>
                  </div>
                </div>

                {/* Info Note */}
                <div className="bg-blue-50 rounded-xl p-3 border border-blue-100">
                  <p className="text-xs text-blue-600">
                    💡 Inflation reduces purchasing power. Your ₹{formatCurrency(result.totalInvestment)} investment
                    today would need to grow to ₹{formatCurrency(result.inflationAdjustedValue)}
                    to maintain the same purchasing power at {inflationRate}% inflation.
                  </p>
                </div>
              </motion.div>
            )}
          </div>

          {/* TIME PERIOD */}
          <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
            <div className="flex items-center justify-between mb-5">
              <label className="font-bold text-[#0b1c39] text-lg">
                Investment Duration
              </label>
              <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-[#2e56b8]">
                {timePeriod} Years
              </div>
            </div>
            <input
              type="range"
              min="1"
              max="40"
              value={timePeriod}
              onChange={(e) => setTimePeriod(Number(e.target.value))}
              className="w-full accent-[#2e56b8]"
            />
            <div className="flex justify-between text-sm text-gray-500 mt-3">
              <span>1 Year</span>
              <span>40 Years</span>
            </div>
          </div>

          {/* BUTTON */}
          <button
            onClick={calculate}
            className="w-full bg-[#2e56b8] hover:bg-[#24479b] text-white py-5 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-xl"
          >
            Calculate Step-Up SIP
          </button>
        </div>

        {/* RIGHT RESULT */}
        {result && (
          <motion.div
            ref={resultRef}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="bg-gradient-to-br from-[#edf3ff] to-[#eef8f1] border border-[#dce7ff] rounded-[35px] p-7"
          >
            <div className="flex items-center gap-3 mb-8">
              <div className="w-14 h-14 rounded-2xl bg-[#2e56b8] text-white flex items-center justify-center">
                <FaChartLine size={24} />
              </div>
              <div>
                <h3 className="text-3xl font-bold text-[#0b1c39]">
                  Investment Summary
                </h3>
                <p className="text-gray-500">Step-Up SIP Growth</p>
              </div>
            </div>

            <div className="space-y-5">
              <div className="bg-white rounded-2xl p-5 flex justify-between">
                <span>Total Investment</span>
                <span className="font-bold">₹{formatCurrency(result.totalInvestment)}</span>
              </div>

              <div className="bg-white rounded-2xl p-5 flex justify-between">
                <span>Estimated Returns</span>
                <span className="font-bold text-[#69bf74]">₹{formatCurrency(result.estimatedReturns)}</span>
              </div>

              {/* Inflation Adjusted Value Card */}
              <div className="bg-gradient-to-r from-orange-50 to-amber-50 rounded-2xl p-5 border border-orange-200">
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Inflation Adjusted Value</span>
                  <span className="font-bold text-orange-600 text-lg">₹{formatCurrency(result.inflationAdjustedValue)}</span>
                </div>
                <div className="flex justify-between items-center mt-2 pt-2 border-t border-orange-100">
                  <span className="text-sm text-gray-500">Value Lost to Inflation</span>
                  <span className="font-bold text-pink-500">-₹{formatCurrency(result.inflationLossValue)}</span>
                </div>
              </div>

              <div className="bg-[#2e56b8] rounded-[30px] p-7 text-white shadow-xl">
                <p className="text-white/80 mb-3 text-lg">
                  Final Future Value
                </p>
                <h2 className="text-4xl md:text-5xl font-extrabold mb-4">
                  ₹{formatCurrency(result.futureValue)}
                </h2>
                <div className="flex items-center gap-2 text-white/90">
                  <FaArrowTrendUp />
                  <span>Additional Gain: {result.gainPercentage}%</span>
                </div>
              </div>

              {/* COMPARISON */}
              <div className="bg-white rounded-3xl p-6 border border-[#e8efff]">
                <h4 className="font-bold text-[#0b1c39] mb-4">
                  Regular SIP vs Step-Up SIP
                </h4>
                <div className="space-y-3 text-sm">
                  <div className="flex justify-between">
                    <span>Regular SIP Value</span>
                    <span className="font-semibold">₹{formatCurrency(result.regularSIPFutureValue)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Extra Gain</span>
                    <span className="font-semibold text-[#69bf74]">₹{formatCurrency(result.extraGain)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Additional Return</span>
                    <span className="font-semibold text-[#69bf74]">+{result.gainPercentage}%</span>
                  </div>
                </div>
              </div>

              {/* Purchasing Power Card */}
              <div className="bg-gradient-to-r from-pink-50 to-rose-50 rounded-2xl p-5 border border-pink-200">
                <h4 className="font-bold text-gray-800 mb-2 flex items-center gap-2">
                  <span className="text-pink-500">ℹ️</span> Purchasing Power Impact
                </h4>
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Today's Investment Value:</span>
                    <span className="font-semibold">₹{formatCurrency(result.totalInvestment)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Purchasing Power Lost:</span>
                    <span className="font-semibold text-pink-600">-₹{formatCurrency(result.purchasingPowerLoss)}</span>
                  </div>
                  <div className="flex justify-between pt-2 border-t border-pink-100">
                    <span className="text-gray-700">Actual Worth Today:</span>
                    <span className="font-bold text-pink-700">₹{formatCurrency(result.inflationAdjustedValue)}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* DOWNLOAD */}
            <button
              onClick={() => setShowForm(true)}
              className="w-full mt-8 bg-[#69bf74] hover:bg-[#58ab63] text-white py-4 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-lg flex items-center justify-center gap-3"
            >
              <FaFilePdf />
              Download Professional PDF Report
            </button>
          </motion.div>
        )}
      </div>

      {/* CHART */}
      {chartData.length > 0 && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="mt-16"
        >
          <h3 className="text-3xl font-bold text-[#0b1c39] mb-8">
            Investment Growth Projection
          </h3>
          <div className="bg-[#f8fbff] rounded-[35px] border border-[#edf3ff] p-6">
            <div className="h-[450px]">
              <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={chartData}>
                  <defs>
                    <linearGradient id="colorStep" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#69bf74" stopOpacity={0.4} />
                      <stop offset="95%" stopColor="#69bf74" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="year" />
                  <YAxis />
                  <Tooltip formatter={(value) => `₹${formatCurrency(value)}`} />
                  <Legend />
                  <Area
                    type="monotone"
                    dataKey="value"
                    stroke="#69bf74"
                    fillOpacity={1}
                    fill="url(#colorStep)"
                    strokeWidth={3}
                    name="Portfolio Value"
                  />
                  <Line
                    type="monotone"
                    dataKey="investment"
                    stroke="#2e56b8"
                    strokeWidth={3}
                    name="Total Investment"
                  />
                  <Line
                    type="monotone"
                    dataKey="inflationAdjusted"
                    stroke="#ff9800"
                    strokeWidth={3}
                    name="Inflation Adjusted"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>
        </motion.div>
      )}

      {/* PDF CONTENT - Hidden */}
      {result && (
        <div id="stepup-result-content" style={{ display: 'none' }}>
          <div style={{ padding: '30px', fontFamily: 'Arial, sans-serif' }}>
            <div style={{ textAlign: 'center', borderBottom: '2px solid #2e56b8', paddingBottom: '20px', marginBottom: '20px' }}>
              <h1 style={{ color: '#2e56b8', marginBottom: '10px' }}>Wisdom Consultancy</h1>
              <p>E-44, Vasant Vihar Society, GIDC-Vadsar Road, Vadodara-390010</p>
              <p>📞 9726344477 | ✉ wisdom2secure@gmail.com</p>
              <h2 style={{ marginTop: '20px', color: '#0b1c39' }}>Step-Up SIP Investment Report</h2>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
              <tbody>
                <tr><td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}><strong>Initial Monthly SIP</strong></td><td style={{ padding: '10px', borderBottom: '1px solid #ddd', textAlign: 'right' }}>₹{formatCurrency(monthlyInvestment)}</td></tr>
                <tr><td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}><strong>Annual Step-Up Rate</strong></td><td style={{ padding: '10px', borderBottom: '1px solid #ddd', textAlign: 'right' }}>{stepUpRate}%</td></tr>
                <tr><td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}><strong>Expected Return</strong></td><td style={{ padding: '10px', borderBottom: '1px solid #ddd', textAlign: 'right' }}>{expectedReturn}%</td></tr>
                <tr><td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}><strong>Inflation Rate</strong></td><td style={{ padding: '10px', borderBottom: '1px solid #ddd', textAlign: 'right' }}>{inflationRate}%</td></tr>
                <tr><td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}><strong>Investment Duration</strong></td><td style={{ padding: '10px', borderBottom: '1px solid #ddd', textAlign: 'right' }}>{timePeriod} Years</td></tr>
                <tr style={{ background: '#f0f0f0' }}><td style={{ padding: '10px' }}><strong>Total Investment</strong></td><td style={{ padding: '10px', textAlign: 'right' }}><strong>₹{formatCurrency(result.totalInvestment)}</strong></td></tr>
                <tr style={{ background: '#f0f0f0' }}><td style={{ padding: '10px' }}><strong>Estimated Returns</strong></td><td style={{ padding: '10px', textAlign: 'right' }}><strong>₹{formatCurrency(result.estimatedReturns)}</strong></td></tr>
                <tr style={{ background: '#f0f0f0' }}><td style={{ padding: '10px' }}><strong>Final Future Value</strong></td><td style={{ padding: '10px', textAlign: 'right' }}><strong>₹{formatCurrency(result.futureValue)}</strong></td></tr>
              </tbody>
            </table>

            <h3 style={{ color: '#2e56b8', marginTop: '20px' }}>📉 Inflation Impact Analysis</h3>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
              <tbody>
                <tr><td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>Today's Value of Investment</td><td style={{ padding: '10px', borderBottom: '1px solid #ddd', textAlign: 'right' }}>₹{formatCurrency(result.totalInvestment)}</td></tr>
                <tr><td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>Purchasing Power Loss</td><td style={{ padding: '10px', borderBottom: '1px solid #ddd', textAlign: 'right', color: '#e91e63' }}>-₹{formatCurrency(result.purchasingPowerLoss)}</td></tr>
                <tr><td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>Inflation Adjusted Value</td><td style={{ padding: '10px', borderBottom: '1px solid #ddd', textAlign: 'right' }}>₹{formatCurrency(result.inflationAdjustedValue)}</td></tr>
                <tr><td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>Total Value Lost to Inflation</td><td style={{ padding: '10px', borderBottom: '1px solid #ddd', textAlign: 'right', color: '#e91e63' }}>-₹{formatCurrency(result.inflationLossValue)}</td></tr>
              </tbody>
            </table>

            <div style={{ marginTop: '30px', padding: '20px', background: '#f5f7fa', borderRadius: '10px' }}>
              <h3>Disclaimer</h3>
              <p style={{ fontSize: '12px' }}>Mutual Fund investments are subject to market risks. Read all scheme related documents carefully before investing. Past performance is not indicative of future returns.</p>
            </div>
          </div>
        </div>
      )}

      {/* FORM */}
      {showForm && (
        <CalculatorForm
          onSubmit={handleFormSubmit}
          onClose={() => setShowForm(false)}
          calculatorType="Step-Up SIP"
          calculationData={{ ...result, chartData }}
          userInputs={{
            monthlyInvestment,
            stepUpRate,
            expectedReturn,
            inflationRate,
            timePeriod
          }}
        />
      )}
    </motion.div>
  );
};

export default StepUpSIPCalculator;